import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { FormularyDrug } from "src/app/backend/models/formulary-drug";
import { environment } from "src/environments/environment";
import { map } from "rxjs/operators";
import { first, isUndefined, omitBy } from "lodash-es";

@Injectable()
export class FormularyBackend {
  constructor(private http: HttpClient) {}

  load(id: string): Observable<FormularyDrug> {
    return this.http.get<FormularyDrug>(
      `${environment.snoots.api.healthcare}/formularies/${id}`
    );
  }

  loadByName(name: string): Observable<FormularyDrug | undefined> {
    return this.list(name).pipe(map((list) => first(list)));
  }

  list(name: string): Observable<FormularyDrug[]> {
    return this.http.get<FormularyDrug[]>(
      `${environment.snoots.api.healthcare}/formularies`,
      {
        params: omitBy(
          {
            name
          },
          isUndefined
        )
      }
    );
  }
}
